/* eslint-disable camelcase */
export const allClients = {
  apps: [
    {
      application_id: 12,
      application_name: 'Smart Cleaning',
      category: 'application',
      dis: 'Track the cleanliness of your spaces and the satisfaction score of services',
      icon_url: 'cleaning_services',
      nav_path: 'ui/smart-cleaning',
      project_id: 451,
      project_name: 'all',
      user_id: '',
    },
    {
      application_id: 10,
      application_name: 'Issues',
      category: 'application',
      dis: 'See all events for any given asset broken down into bite-sized pieces',
      icon_url: 'warning',
      nav_path: 'ui/issue',
      project_id: 451,
      project_name: 'all',
      user_id: '',
    },
    {
      application_id: 14,
      application_name: 'Pipe Monitoring',
      category: 'application',
      dis: 'Get information on pipe monitoring',
      icon_url: 'water_drop',
      nav_path: 'ui/pipe-monitoring',
      project_id: 451,
      project_name: 'all',
      user_id: '',
    },
    {
      application_id: 13,
      application_name: 'Condition Based Maintenance',
      category: 'application',
      dis: 'Get more information on the assets of a site or drill into asset specific issues',
      icon_url: 'mode_fan',
      nav_path: 'ui/cbm',
      project_id: 451,
      project_name: 'all',
      user_id: '',
    },
    {
      application_id: 16,
      application_name: 'Resource Optimization',
      category: 'application',
      dis: 'Get information on resource optimization',
      icon_url: 'energy_savings_leaf',
      nav_path: 'ui/resource-optimization',
      project_id: 451,
      project_name: 'all',
      user_id: '',
    },
    {
      application_id: 38,
      application_name: 'Maintenance Optimizer',
      category: 'application',
      dis: 'A powerful and scalable application designed to optimize maintenance operations through predictive analytics. It leverages machine learning models and advanced algorithms to enhance decision-making in maintenance workflows.',
      icon_url: 'settings_suggest',
      nav_path: 'ui/moe',
      project_id: 451,
      project_name: 'all',
      user_id: '',
    },
  ],
  id: 'all',
  name: 'All Clients',
};
